<template>
  <div
    v-if="(jwtAccessValid() && userProfile.checked && isReciever) || isAdmin"
    class="container1 px-3 justify-content-center"
  >
    <div class="sticky">
      <h1 class="text-center">АКТЫ ПРИЕМКИ</h1>
      <div class="row">
        <div class="col-2">
          <router-link
            class="btn btn-lg btn-primary text-center berry"
            type="button"
            tag="button"
            :to="{ name: 'acceptance', params: { id: 'new' } }"
          >
            ДОБАВИТЬ
          </router-link>
        </div>

        <div class="col-2">
          <button
            class="btn btn-lg btn-success text-center berry"
            type="button"
            @click="exportToExcel()"
          >
            EXCEL
          </button>
        </div>

        <div class="col-2">
          <button
            v-if="isAdmin"
            class="btn btn-lg btn-outline-danger text-center berry"
            type="button"
            @click="cancelDocs()"
          >
            ОТМЕНИТЬ
          </button>
        </div>
        <div class="col-2">
          <input
            v-if="isAdmin"
            class="form-control"
            placeholder="Комментарий отмены"
            v-model="cancelComment"
            type="text"
          />
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-2">
          <v-date-picker
            v-model="dateFrom"
            mode="dateTime"
            is24hr
            :popover="{ visibility: 'focus' }"
          >
            <template v-slot="{ inputValue, inputEvents }">
              <div class="input-group mb-3">
                <div class="input-group-prepend">
                  <span class="input-group-text" id="basic-addon1">Начало</span>
                </div>
                <input
                  class="
                    px-2
                    w-50
                    border
                    rounded
                    focus:outline-none focus:border-blue-300
                  "
                  :value="inputValue"
                  v-on="inputEvents"
                  style="padding-top: 2px; padding-bottom: 2px; line-height: 2"
                />
                <div class="input-group-append">
                  <button class="btn btn-warning" @click="dateFrom = ''">X</button>
                </div>
              </div>
            </template>
          </v-date-picker>
        </div>
        <div class="col-2">
          <v-date-picker v-model="dateTo" mode="dateTime" is24hr :popover="{ visibility: 'focus' }">
            <template v-slot="{ inputValue, inputEvents }">
              <div class="input-group mb-3">
                <div class="input-group-prepend">
                  <span class="input-group-text" id="basic-addon1">Окончание</span>
                </div>
                <input
                  class="
                    px-2
                    w-50
                    border
                    rounded
                    focus:outline-none focus:border-blue-300
                  "
                  :value="inputValue"
                  v-on="inputEvents"
                  style="padding-top: 2px; padding-bottom: 2px; line-height: 2"
                />
                <div class="input-group-append">
                  <button class="btn btn-warning" @click="dateTo = ''">X</button>
                </div>
              </div>
            </template>
          </v-date-picker>
        </div>

        <div class="col-3">
          <Multiselect
            v-model="currentMaster"
            :options="usersWholesaler"
            :loading="false"
            :internal-search="false"
            valueProp="_id"
            trackBy="fullname"
            label="fullname"
            :filterResults="true"
            :minChars="2"
            :resolveOnLoad="true"
            :searchable="true"
            class=""
            noOptionsText="Не найден"
            placeholder="Оптовик"
          >
          </Multiselect>
        </div>
        <div class="col-3">
          <Multiselect
            v-model="currentReceiver"
            :options="users"
            :loading="false"
            :internal-search="false"
            valueProp="_id"
            trackBy="fullname"
            label="fullname"
            :filterResults="true"
            :minChars="2"
            :resolveOnLoad="true"
            :searchable="true"
            class=""
            noOptionsText="Не найден"
            placeholder="Приемщик"
          >
          </Multiselect>
        </div>

        <div class="col-2">
          <input class="form-control" placeholder="Поиск" v-model="searchText" type="text" />
        </div>
      </div>
    </div>
    <div class="tableFixHead mt-2">
      <table class="table" id="report"        
      data-cols-width="30,17,25,14,25,17"
>
        <thead>
          <th>Дата</th>
          <th>Номер</th>
          <th>ФиксПрайс</th>
          <th>Приемщик</th>
          <th>Ягода</th>
          <th>Вес, кг</th>
          <th>Цена, руб/кг</th>
          <th>Сумма, руб</th>
          <th>Сумма бонусов приемщика, руб</th>
          <th>Тип оплаты</th>
          <th>Сдатчик</th>
          <th>Комментарий</th>
          <th></th>
        </thead>

        <tr v-if="exportingToExcel">
          <td>Оптовик</td>
          <td>Дата</td>
          <td>Номер</td>
          <td>ФиксПрайс</td>
          <td>Приемщик</td>
          <td>Ягода</td>
          <td>Вес, кг</td>
          <td>Цена, руб/кг</td>
          <td>Сумма, руб</td>
          <td>Сумма бонусов приемщика, руб</td>
          <td>Тип оплаты</td>
          <td>Сдатчик</td>
          <td>Комментарий</td>
          <td></td>
        </tr>

        <tbody v-for="user in usersWholesaler" :key="user._id"  :id="user._id">
          <tr v-if="!exportingToExcel" class="wholesaler">
            <td>
              <button class="btn btn-light fs-5" @click="setDocVisability(user)">
                <strong>+</strong>
              </button>
            </td>
            <td colspan="12">{{ user.receiver.fullname }}</td>
          </tr>

          <tr
            v-for="doc in docsFilter(user._id)"
            :key="doc._id"
            :class="{ canceled: doc.cancel }"
            @dblclick="router.push({ name: 'acceptance', params: { id: doc._id } })"
          >
            <td v-if="exportingToExcel">{{ user.receiver.fullname }}</td>
            <td>{{ new Date(doc.date).toLocaleString() }}</td>
            <td>{{ doc.prefix }}-{{ doc.number }}</td>
            <td><font-awesome-icon v-if="doc.fixPrice" icon="check" /></td>
            <td>
              <span v-if="doc.company">{{ doc.company.receiver.fullname }}</span>
            </td>
            <td>
              <span v-if="doc.tableUnit[0].berry && doc.tableUnit[0].berry.label">{{
                doc.tableUnit[0].berry.label
              }}</span>
            </td>
            <td data-t="n">
              <span v-if="doc.tableUnit[0].weight">{{ doc.tableUnit[0].weight }}</span>
            </td>
            <td data-t="n">{{ doc.tableUnit[0].price }}</td>
            <td data-t="n">{{ doc.sum.toFixed(2) }}</td>
            <td data-t="n">{{ doc.receiverBonusTotal.toFixed(2) }}</td>
            <td><span v-if="doc.cash">Наличные</span> <span v-if="!doc.cash">На счет</span></td>
            <td>
              <span v-if="!doc.cash"
                >{{ doc.deliverer.passport.lastName }} {{ doc.deliverer.passport.firstName }} ({{
                  doc.deliverer.phone
                }})</span
              >
            </td>
            <td>{{ doc.comment }}</td>
            <td><span v-if="doc.cancel">ОТМЕНЕН</span></td>
          </tr>
        </tbody>

        <tbody id="doc-list"></tbody>
      </table>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-console */
import { ref, computed, onMounted, nextTick } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import useCommonMixin from "@/components/commonMixin.js";
import Multiselect from "@vueform/multiselect";
import TableToExcel from "@linways/table-to-excel";

export default {
  name: "AcceptancesTable",
  components: { Multiselect },

  setup(props) {
    useCommonMixin();
    const { jwtAccessValid, asyncForEach, isReciever, userProfile, isAdmin } = useCommonMixin();
    const store = useStore();
    const router = useRouter();
    const docs = ref([]);
    const profiles = ref([{}]);
    const users = ref([]);
    const roles = ref([]);
    const currentMaster = ref();
    const searchText = ref("");
    const currentReceiver = ref();
    const dateFrom = ref("");
    const dateTo = ref("");
    const cancelComment = ref("");
    const exportingToExcel = ref(false);

    const init = async () => {
      dateFrom.value = new Date(new Date().getFullYear(), 0, 1);
      
      let response = await store.dispatch("FETCHacceptance");
      docs.value = response.status ? response.data : [];
      // asyncForEach(docs.value, async (doc) => {
      //   let response, ind
      //   ind = profiles.value.findIndex(item => item._id == doc.company)
      //   if (ind < 0 ) {
      //     response = await store.dispatch('FETCHuserProfile', {userId: doc.company, phone: null})
      //     profiles.value.push(response)
      //   }
      //   ind = profiles.value.findIndex(item => item._id == doc.deliverer)
      //   if (ind < 0 ) {
      //     response = await store.dispatch('FETCHuserProfile', {userId: doc.deliverer, phone: null})
      //     profiles.value.push(response)
      //   }
      // })

      response = await store.dispatch("FETCHuser", "receiver");
      users.value = response.status ? response.data : [];
      asyncForEach(users.value, async user => {
        user.phone = user.phone ? user.phone.slice(2, 12) : "";
        user.fullname = user.receiver.fullname;
      });

      let responseRoles = await store.dispatch("FETCHroles");
      roles.value = responseRoles.status
        ? responseRoles.data.filter(role => role.type != "deliverer")
        : [];
    };

    const usersWholesaler = computed(() => {
      let wholesalerRole = roles.value.find(item => item.name == "wholesaler");
      let receiverRole = roles.value.find(item => item.name == "receiver");

      let result = [];
      if (wholesalerRole && receiverRole) {
        result = users.value.filter(
          item => item.role == wholesalerRole._id || item.role == receiverRole._id
        );
      }

      if(users.value.length == 1 && users.value[0]._id == userProfile.value._id) {
        result = [{
          _id: userProfile.value.receiver.master,
          receiver:  userProfile.value.receiver,
        }]
      }
      return result;
    });

    const getProfile = profileId => {
      let profileIndex = profiles.value.findIndex(item => item._id == profileId);
      return profileIndex >= 0 ? profiles.value[profileIndex] : { company: "", fullname: "" };
    };

    const docSum = doc => {
      return Object.values(doc.tableUnit).reduce((a, b) => a + b.weight * b.price, 0);
    };

    const docsFilter = computed(() => {
      return (masterId) => {
        let result = docs.value.filter(doc => doc.show && doc.company.receiver.master == masterId);

        // let result = docs.value;
        if (currentMaster.value) {
          result = result.filter(doc => {
            return doc.company ? doc.company.receiver.master == currentMaster.value : false;
          });
        }

        if (currentReceiver.value) {
          result = result.filter(doc => {
            return doc.company ? doc.company._id == currentReceiver.value : false;
          });
        }

        if (dateFrom.value) {
          result = result.filter(doc => {
            return doc.date >= new Date(dateFrom.value).toISOString();
          });
        }

        if (dateTo.value) {
          result = result.filter(doc => {
            return doc.date <= new Date(dateTo.value).toISOString();
          });
        }

        if (searchText.value.length >= 3) {
          result = result.filter(
            doc =>
              JSON.stringify(doc)
                .toLowerCase()
                .indexOf(searchText.value.toLowerCase()) >= 0
          );
        }
        return result;
      };
    });

    const cancelDocs = async () => {
      let confirmСancelDocs = confirm(`Отменить выбранные акты приемки?`);
      if (!confirmСancelDocs) {
        return;
      }

      let acceptances = [];
      docsFilter.value.forEach(item => {
        acceptances.push(item._id);
      });
      response = await store.dispatch("CANCELаcceptances", {
        comment: cancelComment.value,
        acceptances: acceptances
      });

      if (response.status) {
        let data = response.data.data;
        confirm(`Отменено ${data.canceled} из ${data.total}`);
        console.log(response.data);
      }

      let response = await store.dispatch("FETCHacceptance");
      docs.value = response.status ? response.data : [];
    };

    const setDocVisability = masterUser => {
      masterUser.slaveShow = masterUser.slaveShow ? false : true;

      let slaveShow = masterUser.slaveShow;

      docs.value.forEach(doc => {
        if (doc.company.receiver.master == masterUser._id) {
          doc.show = slaveShow;
        }
      });

      //let docListEl = document.getElementById("doc-list");
      //let rowMasterEl = document.getElementById(masterUser._id);
      //rowMasterEl.after(docListEl);
      //masterUser.slaveShow = slaveShow ? false : true;
    };

    const exportToExcel = async () => {
      exportingToExcel.value = true;
      await nextTick()
      let table = document.getElementById("report");
      TableToExcel.convert(table);
      exportingToExcel.value = false;
    };

    onMounted(init);

    return {
      jwtAccessValid,
      isReciever,
      docs,
      getProfile,
      profiles,
      docSum,
      router,
      userProfile,
      isAdmin,
      usersWholesaler,
      currentMaster,
      docsFilter,
      searchText,
      users,
      currentReceiver,
      dateFrom,
      dateTo,
      cancelDocs,
      cancelComment,
      setDocVisability,
      exportingToExcel, 
      exportToExcel,
    };
  }
};
</script>

<style>
.wholesaler {
  background-color: beige;
}
</style>
